export const passwordConstants = {
    FORGOT_PASSWORD_REQUEST: "FORGOT_PASSWORD_REQUEST",
    FORGOT_PASSWORD_SUCCESS: "FORGOT_PASSWORD_SUCCESS",
    FORGOT_PASSWORD_FAILURE: "FORGOT_PASSWORD_FAILURE",
    RESET_PASSWORD_REQUEST: "RESET_PASSWORD_REQUEST",
    RESET_PASSWORD_SUCCESS: "RESET_PASSWORD_SUCCESS",
    RESET_PASSWORD_FAILURE: "RESET_PASSWORD_FAILURE",
    SENDSMS_FORGOT_PASSWORD_REQUEST:"SENDSMS_FORGOT_PASSWORD_REQUEST",
    SENDSMS_FORGOT_PASSWORD_SUCCESS:"SENDSMS_FORGOT_PASSWORD_SUCCESS",
    SENDSMS_FORGOT_PASSWORD_FAILURE:"SENDSMS_FORGOT_PASSWORD_FAILURE",
    HIDE_SMS_MODAL: "HIDE_SMS_MODAL"
  };
  